const validateForm = (data) => {
  let errors = { hasError: false };
  if (!data.code) {
    errors.hasError = true;
    errors.code = true;
  }

  return errors;
};

export default validateForm;